import React, { FunctionComponent, useEffect } from 'react'
import { useQuery } from '@apollo/client'
import { MeetingRequestOptionsQuery, MeetingRequestOptionsQueryVariables } from '../types'
import { MEETING_REQUEST_OPTIONS } from '../graphql/requestMeetingOptions/requestMeetingOptions'
import { useMeetingRequestOptionsStore } from '../graphql/requestMeetingOptions/MeetingRequestOptionsStore'

type MeetingRequestOptionsProviderProps = {
  employeeId: number
  children: React.ReactNode
}

export const MeetingRequestOptionsProvider: FunctionComponent<MeetingRequestOptionsProviderProps> = ({ employeeId, children }) => {
  const { data, error, loading } = useQuery<MeetingRequestOptionsQuery, MeetingRequestOptionsQueryVariables>(MEETING_REQUEST_OPTIONS, {
    variables: { employeeId },
    fetchPolicy: 'network-only',
  })

  const setOptions = useMeetingRequestOptionsStore((state) => state.setOptions)
  const clear = useMeetingRequestOptionsStore((state) => state.clear)

  useEffect(() => {
    setOptions(data ?? null, error ?? null, loading, employeeId)
  }, [data, error, loading, employeeId, setOptions])

  useEffect(() => {
    return () => {
      clear()
    }
  }, [clear])

  return <>{children}</>
}
